<template>
    <div id="app">
        <div class="basic-layout">
            <van-nav-bar @click-left="handleClickLeft" @click-right="handleClickRight" :title="title" fixed
                            :left-arrow="isShowLeftArrow" :right-text="rightText" v-if="isShowTitle" />
            <div class="basic-layout-footer" :class="!isShowTitle ? 'no-padding' : ''">
                <router-view />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'App',
    data() {
        return {}
    },
    watch: {},
    computed: {
        title() {
            return this.$route.meta?.title || '标题'
        },
        isShowTitle() {
            return this.$route.meta?.isShowTitle || false
        },
        isShowLeftArrow() {
            return this.$route.meta?.isShowLeftArrow || false
        },
        rightText() {
            return this.$route.meta?.rightText || ''
        }
    },
    mounted() { },
    methods: {
        handleClickLeft() {
            this.$router.go(-1)
        },
        handleClickRight() {
            window.location.href = `share.html?params=${window.location.href}`
        }
    }
}
</script>
<style lang="less" scoped>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    // text-align: center;
    color: #2c3e50;

    .basic-layout {
        width: 100%;
        height: 100vh;
        box-sizing: border-box;
        font-size: 14px;
        overflow: hidden;

        &-footer {
            padding-top: 46px;
            overflow: hidden;
            height: 100%;
            box-sizing: border-box;

            &.no-padding {
                padding-top: 0;
            }
        }
    }
}
</style>
